import React from 'react';
import styles from './WidgetButton.module.css';
import { Link } from 'react-router-dom';

const WidgetButton = ({ children, href, action }) => {
    if (href) {
        return (
            <Link to={href} className={styles.widget_button}>{children}</Link>
        );
    }

    return (
        <button onClick={() => action()} className={styles.widget_button}>{children}</button>
    );
}

export default WidgetButton;